import { useQuery } from "@apollo/client";
import { GET_VEHICLES_BY_WAREHOUSE_ID, VehiclesResponse } from "../pages/tms/vehicle/graphql/queries/getVehicles";

interface TmsVehicleOption {
    label: string;
    value: number;
}

interface UseTmsVehicleOptionsParams {
    carrierId?: number;
    warehouseId?: number;
}

export const useTmsVehicleOptions = (params?: UseTmsVehicleOptionsParams) => {
    const { data, loading, error } = useQuery<VehiclesResponse>(
        GET_VEHICLES_BY_WAREHOUSE_ID,
        {
            variables: {
                warehouseId: params?.warehouseId,
                status: 1,  // 只查询启用状态的车辆
                carrierId: params?.carrierId  // 根据承运商ID过滤
            },
            // warehouseId 必填：拿不到时跳过查询；carrierId 显式传 null 时也跳过
            skip: !params?.warehouseId || (params?.carrierId !== undefined && params.carrierId === null)
        }
    );

    const vehicleOptions: TmsVehicleOption[] = data?.allVehicles
        ?.map(vehicle => ({
            value: vehicle.id,
            label: `${vehicle.vehicleNumber} - ${vehicle.licensePlate}`,
        })) || [];

    return {
        vehicleOptions,
        vehicles: data?.allVehicles || [],
        loading,
        error
    };
};

